import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PlayerSlider from "../pages/player-slider/Player-slider";

// Functional wrapper component
const PlayerFunctionalWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return <PlayerSlider location={location} navigate={navigate} />;
};

export default PlayerFunctionalWrapper;
